import type { ContextType } from "react";
import { Component } from "react";
import { FormattedMessage } from "react-intl";

import * as Routes from "../../generated/routes";
import { ReturnTo } from "../../utils/ReturnTo";
import { Link } from "../Link";
import { AppContext } from "../shared/AppContext";
import { KibelaSymbol } from "../shared/kibela_symbol";

interface Props {
  currentUserAccount: string;
  canManageTemplates: boolean;
  templates: ReadonlyArray<{ id: number; name: string }>;
}

export class PostButtonDropdown extends Component<Props> {
  static readonly contextType = AppContext;
  declare context: ContextType<typeof AppContext>;

  render() {
    const returnTo = new ReturnTo(this.context.currentUrl);
    const newNotePath = returnTo.addReturnToParam(Routes.newNotePath());

    return (
      <div className="postButtonDropdownContainer">
        <ul className="postButtonDropdown-list">
          <li>
            <Link to={newNotePath} className="postButtonDropdown-list-item">
              <FormattedMessage id="postButtons.writeNote" />
            </Link>
          </li>

          <li>
            {/* eslint-disable @typescript-eslint/naming-convention */}
            <a
              href={Routes.friendlyUserPath(this.props.currentUserAccount, { notes_tab: "private", anchor: "notes" })}
              className="postButtonDropdown-list-item"
            >
              <FormattedMessage id="postButtons.nouns.draftList" />
            </a>
            {/* eslint-enable @typescript-eslint/naming-convention */}
          </li>
        </ul>

        <ul className="postButtonDropdown-list">
          <li>
            <span className="postButtonDropdown-list-titleItem">
              <FormattedMessage id="postButtons.createFromTemplate" />
            </span>
          </li>

          {this.props.templates.map((template) => {
            const href = returnTo.addReturnToParam(Routes.newNoteTemplateNotePath(template.id));
            return (
              <li key={template.id}>
                <a href={href} className="postButtonDropdown-list-item">
                  {template.name}
                </a>
              </li>
            );
          })}

          {this.props.canManageTemplates && (
            <li>
              <a href={Routes.teamSettingWikiTemplatesPath()} className="postButtonDropdown-list-settingItem">
                <KibelaSymbol id="settings" />
                <FormattedMessage id="postButtons.nouns.templateManagement" />
              </a>
            </li>
          )}
        </ul>
      </div>
    );
  }
}
